import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

const OrderTimeCellContent: React.FC<OrderTimeCellContent.Props> = ({
	item,
}) => {
	const { dateFns } = useAppContext();

	const lastReceivedOrder = useMemo(
		() => item?.additionalFields?.transfer?.lastReceivedOrder,
		[item?.additionalFields?.transfer?.lastReceivedOrder],
	);

	const isPreliminary = useMemo(
		() => item?.isPreliminary || lastReceivedOrder?.isPreliminary,
		[item?.isPreliminary, lastReceivedOrder?.isPreliminary],
	);

	const { content, backgroundColor, textColor } = useMemo(() => {
		const content = isPreliminary
			? dateFns.formatTime(item.orderDate, {
					formatTime: "HH:mm:ss",
					timezone: dateFns.timezone,
					isZeroSeconds: true,
					isTimezone: true,
			  })
			: "";

		return {
			content,
			backgroundColor: isPreliminary ? "#7B0078" : undefined,
			textColor: isPreliminary ? "#ffffff" : undefined,
		};
	}, [isPreliminary, dateFns, item.orderDate]);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			textColor={textColor}
			h="100%"
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace OrderTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default OrderTimeCellContent;
